import { SignedDocument } from "../types";
import {
  DOCUMENT_SIGNING_STAGES,
  DOCUMENT_SIGNING_STATUSES,
} from "../constants";

export const hasUnprocessedDocument = (documents: SignedDocument[]) =>
  !!documents.find(
    (document) =>
      document.signatureInfo.signingStage !==
        DOCUMENT_SIGNING_STAGES.FINISHED &&
      !document.signatureInfo.error &&
      document.documentStatus.status !== DOCUMENT_SIGNING_STATUSES.ERROR &&
      !document.documentStatus.errorText
  );
